import { MASSAGE_SET_WSS_URL } from '../store/constants';

const doSetMassageWSSUrl = (payload) => ({
  type: MASSAGE_SET_WSS_URL,
  payload,
});

export { doSetMassageWSSUrl };
